.wrapper {
  flex-direction: column;
  height: 100%;
  background: var(--white-layout-301-level-0-elevation);
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

gz-grid-view {
  .header-buttons {
    padding-right: calc(2 * var(--spacer));
    margin-right: calc(2 * var(--spacer));
    position: relative;
  }

  .inline-block {
    display: inline-block;
  }
}
